const onBlurWorkaround = (event) => {
  const element = event.relatedTarget;
  const focusableElementTagNames = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT"];
  if (element && focusableElementTagNames.includes(element.tagName)) {
    element.focus();
  }
};
export {
  onBlurWorkaround
};
//# sourceMappingURL=radixDialog.js.map
